import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
/** Styles Import */
import "./Style.css";
import "react-datepicker/dist/react-datepicker.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import TranslationService from "../../Services/Translation/TranslationService";
/** Components Import */
import Loading from "../../Components/Loading";
import DatePicker from "react-datepicker";
import { Card, Button, OverlayTrigger, Tooltip, Form, Modal, Badge } from "react-bootstrap";
import SearchInput from "../../Components/SearchInput";
import Dialog from "../../Components/Dialog";
import KakaoAddress from "../../Components/Kakao/DaumPostCode";
import Swal from "../../Components/SweetAlert2";
import AutoTranslate from "../../Components/AutoTranslate";
import RadioButtonGroup from "../../Components/RadioButtonGroup";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCalendar, faClock, faMapMarkerAlt, faEdit, faTrash, faCheck, faTimes, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
/** Date-fns Import */
import { registerLocale } from "react-datepicker";
import ko from "date-fns/locale/ko";

// 한국어 로케일 등록
registerLocale("ko", ko);

function Calendars() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const language = useSelector((state) => state.localStorage.language);
  const authorization = useSelector((state) => state.localStorage.authorization);
  const [userInfo, setUserInfo] = useState({});
  const [dialog, setDialog] = useState(false);
  const [dialogStep, setDialogStep] = useState(0);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [formTitles, setFormTitles] = useState(["작업 예정일 및 사업장 선택", "현장 선택", "기초 건강 진단"]);
  const [formData, setFormData] = useState({
    jobDate: "", // 작업 예정일
    companyCode: "",
    companyName: "",
    siteId: "",
    siteName: "",
    eduId: "",
    constructionTypeList: [],
    constructionTypes: [],
    unitList: [],
    units: [],
    address: "", // 주소
    emergencyPhone: "", // 비상연락처
    highBloodPressure: "", // 최고 혈압
    lowBloodPressure: "", // 최저 혈압
    workExperience: "-1", // 경력
    smoking: "", // 흡연 여부
    drinking: "", // 음주 여부
    pledgeConfirmed: false, // 안전 서약서 동의 여부
  });
  const [companyList, setCompanyList] = useState([]);
  const [translatedCompanyList, setTranslatedCompanyList] = useState([]);
  const [dialogSearchText, setDialogSearchText] = useState("");
  const [checkedSiteList, setCheckedSiteList] = useState([]);
  const [translatedSiteList, setTranslatedSiteList] = useState([]);
  const [dialog1, setDialog1] = useState(false); // 주소검색 창
  const [dialog2, setDialog2] = useState(false); // 정보 확인 창
  const [selectedFormData, setSelectedFormData] = useState({
    jobDate: "",
    companyCode: "",
    companyName: "",
    siteId: "",
    siteName: "",
    date: "",
    eduStatus: "",
    location: "",
  });
  const [dialog3, setDialog3] = useState({ show: false, data: [] }); // 더보기 창
  // 달력 관련 상태
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const datePickerRef = useRef();
  const [wording, setWording] = useState({
    placeholder1: "검색어를 입력해주세요.",
    placeholder2: "비상연락처를 입력하세요.",
    placeholder3: "클릭하면 주소검색 창이 나옵니다.",
    placeholder4: "최고 혈압을 입력하세요.",
    placeholder5: "최저 혈압을 입력하세요.",
  });

  // 필드 에러 상태 추가
  const [fieldErrors, setFieldErrors] = useState({
    address: false,
    highBloodPressure: false,
    lowBloodPressure: false,
    workExperience: false,
    smoking: false,
    drinking: false,
  });

  // 필수 필드 검증 함수
  const validateRequiredFields = () => {
    const errors = {
      address: !formData.address || formData.address.trim() === "",
      highBloodPressure:
        !formData.highBloodPressure ||
        formData.highBloodPressure.trim() === "" ||
        (formData.highBloodPressure && (parseInt(formData.highBloodPressure) < 0 || parseInt(formData.highBloodPressure) >= 150)),
      lowBloodPressure:
        !formData.lowBloodPressure || formData.lowBloodPressure.trim() === "" || (formData.lowBloodPressure && (parseInt(formData.lowBloodPressure) < 0 || parseInt(formData.lowBloodPressure) >= 90)),
      workExperience: formData.workExperience === "-1",
      smoking: formData.smoking === "",
      drinking: formData.drinking === "",
    };
    setFieldErrors(errors);
    return !Object.values(errors).some((error) => error);
  };

  // 필드 변경 시 즉시 검증
  const handleFieldChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    // 혈압 범위 검증
    if (field === "highBloodPressure" || field === "lowBloodPressure") {
      let isValid = true;

      if (value !== "") {
        const numValue = parseInt(value);
        if (isNaN(numValue)) {
          isValid = false;
        } else if (field === "highBloodPressure") {
          isValid = numValue >= 0 && numValue < 150;
        } else if (field === "lowBloodPressure") {
          isValid = numValue >= 0 && numValue < 90;
        }
      } else {
        isValid = true;
      }

      setFieldErrors((prev) => ({
        ...prev,
        [field]: !isValid,
      }));
    } else {
      if (fieldErrors[field]) {
        setFieldErrors((prev) => ({
          ...prev,
          [field]: false,
        }));
      }
    }
  };

  useEffect(() => {
    console.log("location.state: ", location.state);
    Init();
  }, []);

  // 기초 건강진단 단계에서 필드 에러 초기화
  useEffect(() => {
    if (dialogStep === 2) {
      setFieldErrors({
        address: !formData.address || formData.address.trim() === "",
        highBloodPressure:
          !formData.highBloodPressure ||
          formData.highBloodPressure.trim() === "" ||
          (formData.highBloodPressure && (parseInt(formData.highBloodPressure) < 0 || parseInt(formData.highBloodPressure) >= 150)),
        lowBloodPressure:
          !formData.lowBloodPressure ||
          formData.lowBloodPressure.trim() === "" ||
          (formData.lowBloodPressure && (parseInt(formData.lowBloodPressure) < 0 || parseInt(formData.lowBloodPressure) >= 90)),
        workExperience: formData.workExperience === "-1",
        smoking: formData.smoking === "",
        drinking: formData.drinking === "",
      });
    }
  }, [dialogStep, formData.address, formData.highBloodPressure, formData.lowBloodPressure, formData.workExperience, formData.smoking, formData.drinking]);

  useEffect(() => {
    if (!authorization.auth) {
      navigate("/");
    }
  }, [authorization.auth]);

  // 언어 변경 시 formTitles 다시 번역
  useEffect(() => {
    const translateFormTitles = async () => {
      try {
        const originalTitles = ["작업 예정일 및 사업장 선택", "현장 선택", "기초 건강 진단"];
        const translatedTitles = await Promise.all(originalTitles.map((title) => TranslationService.translateText(title, language.lang)));
        setFormTitles(translatedTitles);
      } catch (e) {
        console.log("Translate formTitles error: ", e);
      }
    };

    translateFormTitles();
  }, [language.lang]);

  // 언어 변경 시 회사명 다시 번역
  useEffect(() => {
    const translateCompanyNames = async () => {
      try {
        if (companyList.length > 0) {
          const translatedItems = await Promise.all(
            companyList.map(async (item) => ({
              ...item,
              translatedCompanyName: await TranslationService.translateText(item.companyName, language.lang),
            }))
          );
          setTranslatedCompanyList(translatedItems);
        }
      } catch (e) {
        console.log("Translate company names error: ", e);
      }
    };

    translateCompanyNames();
  }, [language.lang, companyList]);

  // 자동으로 다음 단계로 진행하는 useEffect
  useEffect(() => {
    if (dialogStep === 0 && formData.siteId && formData.siteName) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (formData.jobDate && dateRegex.test(formData.jobDate)) {
        // 연도 범위 검사 (1900년~2500년)
        const year = parseInt(formData.jobDate.split("-")[0]);
        if (year >= 1900 && year <= 2500) {
          setDialogStep(1);
          setDialogSearchText("");
        }
      }
    }
  }, [formData]);

  const Init = async () => {
    try {
      const userData = await IndexedDb.GetUserInfo();
      setUserInfo(userData);

      // formTitles 번역
      const originalTitles = ["작업 예정일 및 사업장 선택", "현장 선택", "기초 건강 진단"];
      const translatedTitles = await Promise.all(originalTitles.map((title) => TranslationService.translateText(title, language.lang)));
      setFormTitles(translatedTitles);

      // wording 번역
      const _placeholder1 = await TranslationService.translateText(wording.placeholder1, language.lang);
      const _placeholder2 = await TranslationService.translateText(wording.placeholder2, language.lang);
      const _placeholder3 = await TranslationService.translateText(wording.placeholder3, language.lang);
      const _placeholder4 = await TranslationService.translateText(wording.placeholder4, language.lang);
      const _placeholder5 = await TranslationService.translateText(wording.placeholder5, language.lang);
      setWording({ ...wording, placeholder1: _placeholder1, placeholder2: _placeholder2, placeholder3: _placeholder3, placeholder4: _placeholder4, placeholder5: _placeholder5 });

      await Search();
    } catch (e) {
      console.log("Init Error: ", e);
    }
  };

  const Search = async (_year = selectedDate.getFullYear(), _month = selectedDate.getMonth() + 1) => {
    try {
      setLoading(true);
      const response = await Commons.Axios("get", `${Global.base.useUrl + Global.urls.Content.Calendar}?year=${_year}&month=${_month}`);
      console.log("Search response: ", response);
      if (response.status === 200 && Array.isArray(response.data)) {
        const _events = response.data.map((item) => {
          return {
            company: { companyCode: item.company.companyCode, companyname: item.company.companyName },
            site: { siteId: item.site.siteId, sitename: item.site.siteName },
            jobDate: new Date(item.hse.jobDate),
            date: new Date(item.edu.createDate),
            eduStatus: item.edu.approvalState,
            location: item.site.location,
          };
        });
        setEvents(_events);
      } else if (response.status === 401) {
        navigate("/");
      } else {
        setEvents([]);
        throw new Error(JSON.stringify(response.data));
      }
    } catch (e) {
      console.log("Search Error: ", e);
      // CORS 에러나 네트워크 에러, 500 에러 등의 경우 홈으로 이동
      if (e.code === "ERR_NETWORK" || e.message === "Network Error" || (e.response && (e.response.status === 500 || e.response.status === 0))) {
        navigate("/");
      } else {
        setEvents([]);
      }
    } finally {
      setLoading(false);
    }
  };

  // 사업장 검색 로직
  const Search1 = async () => {
    try {
      setDialogLoading(true);
      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.commonCompany, {
        q: dialogSearchText,
        page: 1,
        pageSize: 1000,
      });

      let data = result.data;
      console.log("Search1: ", data);

      if (!data) {
        throw new Error(data);
      } else if (data.type === "Error") {
        throw new Error(data.message);
      } else {
        setCompanyList(data.items);

        // 회사명 번역
        const translatedItems = await Promise.all(
          data.items.map(async (item) => ({
            ...item,
            translatedCompanyName: await TranslationService.translateText(item.companyName, language.lang),
          }))
        );
        console.log("translatedItems: ", translatedItems);
        setTranslatedCompanyList(translatedItems);
      }
    } catch (e) {
      console.log("Search1 Error: ", e);
    } finally {
      setDialogLoading(false);
    }
  };

  // 보건 교육 카드 만들 수 있는지 체크하는 로직
  const Search2 = async (_companyCode = formData.companyCode) => {
    try {
      setDialogLoading(true);
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.RiskFactor.Availability, {
        companyCode: _companyCode,
      });
      console.log("Search2 response: ", response.data);
      if (response.status === 200) {
        let _count = 0;
        if (Array.isArray(response.data)) {
          response.data.forEach((item) => {
            if (item.canApply === "N") {
              _count++;
            }
          });
        }
        setCheckedSiteList(response.data);
        if (_count === response.data.length) {
          setDialogSearchText("");
          setDialogStep(0);
          Swal.warning("보건 교육 카드 만들 수 있는 현장이 없습니다.");
        } else {
          setDialogSearchText("");
        }
      } else {
        throw new Error(JSON.stringify(response));
      }
    } catch (e) {
      console.log("Search2 error: ", e);
    } finally {
      setDialogLoading(false);
    }
  };

  // 교육 승인 요청 로직
  const Sumit = async (_param = "") => {
    try {
      if (!formData.address) {
        Swal.warning("주소를 입력해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (!formData.highBloodPressure) {
        Swal.warning("최고 혈압을 입력해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (!formData.lowBloodPressure) {
        Swal.warning("최저 혈압을 입력해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }

      const highBP = parseInt(formData.highBloodPressure);
      const lowBP = parseInt(formData.lowBloodPressure);

      if (isNaN(highBP) || highBP < 0 || highBP >= 150) {
        Swal.warning("최고 혈압은 0 이상 150 미만으로 입력해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }

      if (isNaN(lowBP) || lowBP < 0 || lowBP >= 90) {
        Swal.warning("최저 혈압은 0 이상 90 미만으로 입력해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (formData.workExperience === "-1") {
        Swal.warning("경력을 선택해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (formData.smoking === "0") {
        Swal.warning("흡연 여부를 선택해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      if (formData.drinking === "0") {
        Swal.warning("음주 여부를 선택해주세요.");
        setDialogStep(2);
        setDialog(true);
        return;
      }
      let params = {
        siteId: formData.siteId,
        companyCode: formData.companyCode,
        empId: userInfo.userId,
        eduId: 0,
        jobDate: formData.jobDate,
        address: formData.address,
        phone: userInfo.tel ?? "",
        emergencyPhone: formData.emergencyPhone,
        highBloodPressure: formData.highBloodPressure,
        lowBloodPressure: formData.lowBloodPressure,
        workExperience: formData.workExperience,
        smoking: formData.smoking,
        drinking: formData.drinking,
        healthCheck: {},
        ppeIssueStatus: {},
        constructionTypes: formData.constructionTypes,
        units: formData.units,
        pledgeConfirmed: formData.pledgeConfirmed,
      };
      console.log("Sumit params: ", JSON.stringify(params));
      await Commons.Axios("post", Global.base.useUrl + Global.urls.Content.HealthSafety, {}, JSON.stringify(params)).then((result) => {
        let data = result.data;
        console.log("Sumit: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Swal.success("교육 신청이 완료되었습니다.");
          setFormData({
            jobDate: "", // 작업 예정일
            companyCode: "",
            companyName: "",
            siteId: "",
            siteName: "",
            eduId: "",
            constructionTypeList: [],
            constructionTypes: [],
            unitList: [],
            units: [],
            address: "", // 주소
            emergencyPhone: "", // 비상연락처
            highBloodPressure: "", // 최고 혈압
            lowBloodPressure: "", // 최저 혈압
            workExperience: "-1", // 경력
            smoking: "0", // 흡연 여부
            drinking: "0", // 음주 여부
            pledgeConfirmed: false, // 안전 서약서 동의 여부
          });
          Init();
        }
      });
    } catch (e) {
      console.log("Sumit Error: ", e);
    } finally {
      setLoading(false);
    }
  };

  const NextStep = () => {
    if (dialogStep === formTitles.length - 1) {
      console.log("formData: ", formData);
      setDialog(false);

      setDialogStep(0);
      setDialogSearchText("");
      setCompanyList([]);
      setCheckedSiteList([]);
      Sumit(formData.siteId);
      return;
    }

    switch (dialogStep) {
      case 0: // 작업 예정일 및 현장 선택
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (formData.jobDate && dateRegex.test(formData.jobDate) && formData.companyCode) {
          // 연도 범위 검사 (1900년~2500년)
          const year = parseInt(formData.jobDate.split("-")[0]);
          if (year < 1900 || year > 2500) {
            Swal.warning("작업 예정일은 1900년~2500년 사이의 날짜만 입력 가능합니다.");
            return;
          }
          setDialogStep(1);
          setDialogSearchText("");
          Search2(formData.companyCode);
        } else {
          if (!formData.jobDate) {
            Swal.warning("작업 예정일을 입력해주세요.");
          } else if (!dateRegex.test(formData.jobDate)) {
            Swal.warning("작업 예정일 형식이 올바르지 않습니다.");
          } else if (!formData.companyCode) {
            Swal.warning("사업장을 선택해주세요.");
          }
        }
        break;
      case 1: // 현장 선택
        if (formData.siteId) {
          setDialogStep(2);
          setDialogSearchText("");
        } else {
          Swal.warning("현장을 선택해주세요.");
        }
        break;
      case 2: // 기초 건강진단
        if (validateRequiredFields()) {
          setDialogStep(3);
          setDialogSearchText("");
        } else {
          Swal.warning("필수 항목을 모두 입력해주세요.");
        }
        break;
      default:
        setDialogStep(dialogStep + 1);
        break;
    }
  };

  const HandleReceivePost = (data) => {
    console.log("HandleReceivePost data: ", data);
    setFormData((prev) => ({
      ...prev,
      address: data.address,
    }));
    // 주소가 설정되면 에러 상태 해제
    setFieldErrors((prev) => ({
      ...prev,
      address: false,
    }));
    setDialog1(false);
  };

  // 선택된 날짜의 일정들 가져오기
  const getEventsForDate = (date) => {
    return events.filter((event) => event.jobDate.getDate() === date.getDate() && event.jobDate.getMonth() === date.getMonth() && event.jobDate.getFullYear() === date.getFullYear());
  };

  // 커스텀 날짜 렌더링 (각 날짜 셀에 일정 제목 최대 2~3개 노출, +버튼 제거)
  const renderDayContents = (day, date) => {
    const eventsOnDate = getEventsForDate(date);
    const isToday = new Date().toDateString() === date.toDateString();
    const isSelected = selectedDate.toDateString() === date.toDateString();

    return (
      <div className={`custom-day-content ${isToday ? "today" : ""} ${isSelected ? "selected" : ""}`}>
        <div className='flex-between-center w-100'>
          <span className='day-number'>{day}</span>
          {!Commons.IsMobile() && isSelected && (
            <div
              className='flex-start-center gap-1 cursor-pointer'
              onClick={() => {
                setFormData({ ...formData, jobDate: Commons.DateFormating(selectedDate, 2) });
                setDialog(true);
              }}
            >
              <FontAwesomeIcon style={{ color: "#222222" }} icon={faPlus} size='lg' />
              <span className='me-2' style={{ color: "#222222", fontSize: "1rem" }}>
                <AutoTranslate targetLanguage={language.lang}>추가</AutoTranslate>
              </span>
            </div>
          )}
        </div>
        <div className='calendar-event-list'>
          {eventsOnDate.slice(0, 3).map((event, idx) => (
            <div
              key={idx}
              className={`calendar-event-title ${event.eduStatus == "W" ? "calendar-event-title-warning" : event.eduStatus == "Y" ? "calendar-event-title-approval" : "calendar-event-title-danger"}`}
              title={event.site.sitename}
              onClick={(e) => {
                console.log("event: ", event);
                e.stopPropagation();
                setSelectedFormData({
                  jobDate: Commons.DateFormating(event.jobDate, 2),
                  companyCode: event.company.companyCode,
                  companyName: event.company.companyname,
                  siteId: event.site.siteId,
                  siteName: event.site.sitename,
                  date: Commons.DateFormating(event.date, 2),
                  eduStatus: event.eduStatus,
                  location: event.location,
                });
                setDialog2(true);
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>{event.site.sitename}</AutoTranslate>
            </div>
          ))}
          {eventsOnDate.length > 3 && (
            <div className='calendar-event-more cursor-pointer' onClick={() => setDialog3({ show: true, data: eventsOnDate })}>
              +{eventsOnDate.length - 3}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      {loading && <Loading />}
      <div className='edu-calendar-flex-container'>
        <div className='calendar-card-container w-100 my-3' style={{ position: "relative" }}>
          <DatePicker
            ref={datePickerRef}
            calendarClassName='custom-calendar calendar-large'
            dateFormat='yyyy-MM-dd'
            locale={ko}
            inline
            selected={selectedDate}
            onYearChange={(yearOrDate) => {
              let year = yearOrDate;
              let month = selectedDate.getMonth() + 1;
              if (typeof yearOrDate === "object" && yearOrDate instanceof Date) {
                year = yearOrDate.getFullYear();
                month = yearOrDate.getMonth() + 1;
              }
              Search(year, month);
            }}
            onMonthChange={(monthOrDate) => {
              let year = selectedDate.getFullYear();
              let month = monthOrDate;
              if (typeof monthOrDate === "object" && monthOrDate instanceof Date) {
                year = monthOrDate.getFullYear();
                month = monthOrDate.getMonth() + 1;
              } else {
                month = monthOrDate + 1;
              }
              Search(year, month);
            }}
            onChange={(date) => {
              setSelectedDate(date);
              setFormData({ ...formData, jobDate: Commons.DateFormating(date, 2) });
            }}
            renderDayContents={renderDayContents}
            highlightDates={Array.isArray(events) ? events.map((event) => new Date(event.date)) : []}
            renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
              <React.Fragment>
                <div className='calendar-header-row'>
                  <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className='calendar-header-arrow' aria-label='이전달'>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <div className='calendar-header-selects'>
                    <select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(Number(value))} className='react-datepicker__year-select'>
                      {Array(30)
                        .fill(0)
                        .map((_, i) => {
                          const year = new Date().getFullYear() - 10 + i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                    </select>
                    <select value={date.getMonth()} onChange={({ target: { value } }) => changeMonth(Number(value))} className='react-datepicker__month-select'>
                      {Array(12)
                        .fill(0)
                        .map((_, i) => (
                          <option key={i} value={i}>
                            {(i + 1).toString().padStart(2, "0")}월
                          </option>
                        ))}
                    </select>
                  </div>
                  <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} className='calendar-header-arrow' aria-label='다음달'>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                </div>
                <div className='calendar-header-row'>
                  <div />
                  <div className='flex-start-center gap-3'>
                    <span className='calendar-header-title'>
                      {date.getFullYear()}
                      <AutoTranslate targetLanguage={language.lang}>년</AutoTranslate> {(date.getMonth() + 1).toString().padStart(2, "0")}
                      <AutoTranslate targetLanguage={language.lang}>월</AutoTranslate>
                    </span>
                    <div>
                      <Button
                        className='calendar-today-btn'
                        size='sm'
                        onClick={() => {
                          const today = new Date();
                          setSelectedDate(today);
                          setFormData({ ...formData, jobDate: Commons.DateFormating(today, 2) });
                          Search(today.getFullYear(), today.getMonth() + 1);
                          if (datePickerRef.current) {
                            datePickerRef.current.setPreSelection(today);
                          }
                        }}
                      >
                        <AutoTranslate targetLanguage={language.lang}>오늘</AutoTranslate>
                      </Button>
                    </div>
                  </div>
                  <div />
                </div>
              </React.Fragment>
            )}
          />
        </div>
        {Commons.IsMobile() && (
          <div className='w-100'>
            <Card>
              <Card.Header className='flex-between-center'>
                <h5 className='mb-0'>
                  <AutoTranslate targetLanguage={language.lang}>
                    {selectedDate.toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}{" "}
                    일정
                  </AutoTranslate>
                </h5>
                <FontAwesomeIcon
                  style={{ color: "#000000", fontSize: "1.2rem", cursor: "pointer" }}
                  icon={faPlus}
                  onClick={() => {
                    setFormData({ ...formData, jobDate: Commons.DateFormating(selectedDate, 2) });
                    setDialog(true);
                  }}
                />
              </Card.Header>
              <Card.Body>
                {getEventsForDate(selectedDate).length > 0 ? (
                  getEventsForDate(selectedDate).map((event, index) => {
                    console.log("event: ", event);
                    return (
                      <div key={index} className='event-item mb-3 p-3 border rounded'>
                        <div className='d-flex justify-content-between align-items-start'>
                          <div className='flex-grow-1'>
                            <div className='d-flex align-items-center mb-2'>
                              <h6 className='mb-0 me-2'>
                                <AutoTranslate targetLanguage={language.lang}>{event.site.sitename}</AutoTranslate>
                              </h6>
                            </div>
                            <p className='text-muted mb-1'>
                              <AutoTranslate targetLanguage={language.lang}>{event.company.companyname}</AutoTranslate>
                            </p>
                            <div className='d-flex align-items-center text-muted small'>
                              {event.location && (
                                <>
                                  <FontAwesomeIcon icon={faMapMarkerAlt} className='me-1' />
                                  <span>
                                    <AutoTranslate targetLanguage={language.lang}>{event.location}</AutoTranslate>
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                          <div className='d-flex gap-1'>
                            <Button
                              size='sm'
                              variant='outline-primary'
                              onClick={() =>
                                navigate("/composed-education", {
                                  state: {
                                    company: { companyCode: event.company.companyCode, companyName: event.company.companyname },
                                    site: { siteId: event.site.siteId, siteName: event.site.sitename },
                                  },
                                })
                              }
                            >
                              <FontAwesomeIcon icon={faChevronRight} />
                            </Button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className='text-center text-muted py-4'>
                    <FontAwesomeIcon icon={faCalendar} size='2x' className='mb-3' />
                    <p>
                      <AutoTranslate targetLanguage={language.lang}>이 날짜에는 일정이 없습니다.</AutoTranslate>
                    </p>
                    <Button
                      variant='outline-primary'
                      onClick={() => {
                        setFormData({ ...formData, jobDate: Commons.DateFormating(selectedDate, 2) });
                        setDialog(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faPlus} className='me-1' />
                      <AutoTranslate targetLanguage={language.lang}>새 일정 추가</AutoTranslate>
                    </Button>
                  </div>
                )}
              </Card.Body>
            </Card>
            <div style={{ height: "16px" }} />
          </div>
        )}
      </div>
      <Dialog
        show={dialog}
        onHide={() => {
          setDialog(false);
          setFormData({
            jobDate: "", // 작업 예정일
            companyCode: "",
            companyName: "",
            siteId: "",
            siteName: "",
            eduId: "",
            constructionTypeList: [],
            constructionTypes: [],
            unitList: [],
            units: [],
            address: "", // 주소
            emergencyPhone: "", // 비상연락처
            highBloodPressure: "", // 최고 혈압
            lowBloodPressure: "", // 최저 혈압
            workExperience: "-1", // 경력
            smoking: "", // 흡연 여부
            drinking: "", // 음주 여부
            pledgeConfirmed: false, // 안전 서약서 동의 여부
          });
          setDialogSearchText("");
          setCompanyList([]);
          setTranslatedCompanyList([]);
          setCheckedSiteList([]);
          setDialogStep(0);
        }}
        title={formTitles[dialogStep]}
        fullScreen={Commons.IsMobile()}
        backdrop={false}
        className='modern-dialog'
        footerChildren={
          <div className='flex-between-center w-100'>
            <Button variant='outline-secondary' className='modern-btn modern-btn-outline-secondary' onClick={() => setDialogStep(dialogStep - 1)} disabled={dialogStep === 0}>
              <FontAwesomeIcon icon={faChevronLeft} />
              <AutoTranslate targetLanguage={language.lang}>이전</AutoTranslate>
            </Button>
            <Button className='modern-btn modern-btn-outline-primary' onClick={NextStep}>
              {dialogStep === formTitles.length - 1 ? <AutoTranslate targetLanguage={language.lang}>완료</AutoTranslate> : <AutoTranslate targetLanguage={language.lang}>다음</AutoTranslate>}
              {dialogStep != formTitles.length - 1 && <FontAwesomeIcon icon={faChevronRight} />}
            </Button>
          </div>
        }
      >
        <div style={{ height: Commons.IsMobile() ? "" : "60vh", overflowY: "auto" }}>
          {dialogLoading && <Loading />}
          {dialogStep === 0 && (
            <div>
              <Form className='w-100 mb-4 px-2' onSubmit={(e) => e.preventDefault()}>
                <Form.Group className='modern-form-group'>
                  <Form.Label className='modern-form-label'>
                    <AutoTranslate targetLanguage={language.lang}>작업 예정일</AutoTranslate>
                  </Form.Label>
                  <Form.Control
                    className='modern-form-control'
                    type='text'
                    placeholder={`작업 예정일을 입력하세요. (예: ${Commons.DateFormating(new Date(), 2)})`}
                    value={formData.jobDate}
                    onChange={(e) => setFormData({ ...formData, jobDate: Commons.InputDateFormating(e.target.value) })}
                  />
                </Form.Group>
              </Form>
              <div className='mb-4 modern-divider' />
              <Form className='w-100 mb-1 px-2' onSubmit={(e) => e.preventDefault()}>
                <Form.Group className='modern-form-group'>
                  <Form.Label className='modern-form-label'>
                    <AutoTranslate targetLanguage={language.lang}>사업장 선택</AutoTranslate>
                  </Form.Label>
                </Form.Group>
              </Form>
              <div className='mb-5'>
                <SearchInput isStartIcon isEndXIcon autoFocus placeholder={wording.placeholder1} text={dialogSearchText} setText={(e) => setDialogSearchText(e)} onSumit={Search1} />
              </div>
              <div className='flex-start-center flex-wrap gap-3 px-2'>
                {Array.isArray(translatedCompanyList) && translatedCompanyList.length > 0 ? (
                  translatedCompanyList
                    ?.filter((item) => String(item.companyName || "").includes(dialogSearchText))
                    .map((item, index) => {
                      return (
                        <Button
                          key={index}
                          className={`${formData.companyCode === item.companyCode ? "modern-btn-primary" : "modern-btn-outline-primary"} modern-search-result-btn`}
                          size='lg'
                          onClick={() => setFormData({ ...formData, companyCode: item.companyCode, companyName: item.companyName })}
                        >
                          {item.translatedCompanyName || item.companyName}
                        </Button>
                      );
                    })
                ) : (
                  <div className='modern-empty-state w-100'>
                    <p style={{ margin: 0 }}>
                      <AutoTranslate targetLanguage={language.lang}>사업장을 검색하여 선택해주세요.</AutoTranslate>
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
          {dialogStep === 1 && (
            <div>
              <Form className='w-100 mb-1 px-2' onSubmit={(e) => e.preventDefault()}>
                <Form.Group className='modern-form-group'>
                  <Form.Label className='modern-form-label'>
                    <AutoTranslate targetLanguage={language.lang}>현장 선택</AutoTranslate>
                  </Form.Label>
                </Form.Group>
              </Form>
              <div className='mb-5'>
                <SearchInput isStartIcon isEndXIcon placeholder={wording.placeholder1} text={dialogSearchText} setText={(e) => setDialogSearchText(e)} />
              </div>
              <div className='flex-start-center flex-wrap gap-3 px-2'>
                {checkedSiteList
                  ?.filter((item) => String(item.siteName || "").includes(dialogSearchText))
                  .map((item, index) => {
                    return (
                      <Button
                        key={index}
                        className={`${formData.siteId === item.siteId ? "modern-btn-primary" : "modern-btn-outline-primary"} modern-search-result-btn`}
                        size='lg'
                        disabled={item.canApply === "N"}
                        onClick={() => setFormData({ ...formData, siteId: item.siteId, siteName: item.siteName })}
                      >
                        <AutoTranslate targetLanguage={language.lang}>{item.siteName}</AutoTranslate>
                      </Button>
                    );
                  })}
              </div>
            </div>
          )}
          {dialogStep === 2 && (
            <div>
              <Form onSubmit={(e) => e.preventDefault()}>
                <div className={`${Commons.IsMobile() ? "w-100" : "flex-between-center gap-3 w-100"} mb-4 px-2`}>
                  <Form.Group className={`${Commons.IsMobile() ? "w-100" : "w-50"} modern-form-group`}>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>성명</AutoTranslate>
                    </Form.Label>
                    <Form.Control className='modern-form-control' type='text' value={userInfo.userNm ?? ""} disabled />
                  </Form.Group>
                  {!Commons.IsMobile() && (
                    <Form.Group className='w-50 modern-form-group'>
                      <Form.Label className='modern-form-label'>
                        <AutoTranslate targetLanguage={language.lang}>생년월일</AutoTranslate>
                      </Form.Label>
                      <Form.Control className='modern-form-control' type='text' value={userInfo.birth ?? ""} disabled />
                    </Form.Group>
                  )}
                </div>
                {Commons.IsMobile() && (
                  <div className='w-100 mb-4 px-2'>
                    <Form.Group className='w-100 modern-form-group'>
                      <Form.Label className='modern-form-label'>
                        <AutoTranslate targetLanguage={language.lang}>생년월일</AutoTranslate>
                      </Form.Label>
                      <Form.Control className='modern-form-control' type='text' value={userInfo.birth ?? ""} disabled />
                    </Form.Group>
                  </div>
                )}
                <div className={`${Commons.IsMobile() ? "w-100" : "flex-between-center gap-3 w-100"} mb-4 px-2`}>
                  <Form.Group className={`${Commons.IsMobile() ? "w-100" : "w-50"} modern-form-group`}>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>연락처</AutoTranslate>
                    </Form.Label>
                    <Form.Control className='modern-form-control' type='text' value={userInfo.tel ?? ""} disabled />
                  </Form.Group>
                  {!Commons.IsMobile() && (
                    <Form.Group className='w-50 modern-form-group'>
                      <Form.Label className='modern-form-label'>
                        <AutoTranslate targetLanguage={language.lang}>비상연락처</AutoTranslate>
                      </Form.Label>
                      <Form.Control
                        className='modern-form-control'
                        type='tel'
                        placeholder={wording.placeholder2}
                        value={formData.emergencyPhone}
                        onChange={(e) => setFormData({ ...formData, emergencyPhone: Commons.FormatPhoneNumber(e.target.value, formData.emergencyPhone) })}
                      />
                    </Form.Group>
                  )}
                </div>
                {Commons.IsMobile() && (
                  <div className='w-100 mb-4 px-2'>
                    <Form.Group className='w-100 modern-form-group'>
                      <Form.Label className='modern-form-label'>
                        <AutoTranslate targetLanguage={language.lang}>비상연락처</AutoTranslate>
                      </Form.Label>
                      <Form.Control
                        className='modern-form-control'
                        type='tel'
                        placeholder={wording.placeholder2}
                        value={formData.emergencyPhone}
                        onChange={(e) => setFormData({ ...formData, emergencyPhone: Commons.FormatPhoneNumber(e.target.value, formData.emergencyPhone) })}
                      />
                    </Form.Group>
                  </div>
                )}
                <div className='w-100 mb-4 px-2'>
                  <Form.Group className='w-100 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>주소</AutoTranslate>
                      <span style={{ color: "#dc3545", fontWeight: "bold" }}>&#42;</span>
                    </Form.Label>
                    <Form.Control
                      className={`modern-form-control ${fieldErrors.address ? "error-field" : ""}`}
                      type='text'
                      placeholder={wording.placeholder3}
                      value={formData.address}
                      onClick={() => setDialog1(true)}
                      readOnly
                    />
                    <div className='error-message'>{fieldErrors.address ? <AutoTranslate targetLanguage={language.lang}>주소를 입력해주세요.</AutoTranslate> : <span>&nbsp;</span>}</div>
                  </Form.Group>
                </div>
                <div className={`${Commons.IsMobile() ? "w-100" : "flex-between-center gap-3 w-100"} mb-4 px-2`}>
                  <Form.Group className={`${Commons.IsMobile() ? "w-100" : "w-50"} modern-form-group`}>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>최고 혈압</AutoTranslate> (<AutoTranslate targetLanguage={language.lang}>기준: 150미만</AutoTranslate>)
                      <span style={{ color: "#dc3545", fontWeight: "bold" }}>&#42;</span>
                    </Form.Label>
                    <Form.Control
                      className={`modern-form-control ${fieldErrors.highBloodPressure ? "error-field" : ""}`}
                      type='number'
                      placeholder={wording.placeholder4}
                      value={formData.highBloodPressure}
                      onChange={(e) => handleFieldChange("highBloodPressure", e.target.value)}
                    />
                    <div className='error-message'>
                      {fieldErrors.highBloodPressure ? <AutoTranslate targetLanguage={language.lang}>최고 혈압은 0 이상 150 미만으로 입력해주세요.</AutoTranslate> : <span>&nbsp;</span>}
                    </div>
                  </Form.Group>
                  {!Commons.IsMobile() && (
                    <Form.Group className='w-50 modern-form-group'>
                      <Form.Label className='modern-form-label'>
                        <AutoTranslate targetLanguage={language.lang}>최저 혈압</AutoTranslate> (<AutoTranslate targetLanguage={language.lang}>기준: 90미만</AutoTranslate>)
                        <span style={{ color: "#dc3545", fontWeight: "bold" }}>&#42;</span>
                      </Form.Label>
                      <Form.Control
                        className={`modern-form-control ${fieldErrors.lowBloodPressure ? "error-field" : ""}`}
                        type='number'
                        placeholder={wording.placeholder5}
                        value={formData.lowBloodPressure}
                        onChange={(e) => handleFieldChange("lowBloodPressure", e.target.value)}
                      />
                      <div className='error-message'>
                        {fieldErrors.lowBloodPressure ? <AutoTranslate targetLanguage={language.lang}>최저 혈압은 0 이상 90 미만으로 입력해주세요.</AutoTranslate> : <span>&nbsp;</span>}
                      </div>
                    </Form.Group>
                  )}
                </div>
                {Commons.IsMobile() && (
                  <div className='w-100 mb-4 px-2'>
                    <Form.Group className='w-100 modern-form-group'>
                      <Form.Label className='modern-form-label'>
                        <AutoTranslate targetLanguage={language.lang}>최저 혈압</AutoTranslate> (<AutoTranslate targetLanguage={language.lang}>기준: 90미만</AutoTranslate>)
                        <span style={{ color: "#dc3545", fontWeight: "bold" }}>&#42;</span>
                      </Form.Label>
                      <Form.Control
                        className={`modern-form-control ${fieldErrors.lowBloodPressure ? "error-field" : ""}`}
                        type='number'
                        placeholder={wording.placeholder5}
                        value={formData.lowBloodPressure}
                        onChange={(e) => handleFieldChange("lowBloodPressure", e.target.value)}
                      />
                      <div className='error-message'>
                        {fieldErrors.lowBloodPressure ? <AutoTranslate targetLanguage={language.lang}>최저 혈압은 0 이상 90 미만으로 입력해주세요.</AutoTranslate> : <span>&nbsp;</span>}
                      </div>
                    </Form.Group>
                  </div>
                )}
                <div className='w-100 mb-4 px-2'>
                  <Form.Group className='w-100 modern-form-group'>
                    <Form.Label className='modern-form-label'>
                      <AutoTranslate targetLanguage={language.lang}>경력 선택</AutoTranslate>
                      <span style={{ color: "#dc3545", fontWeight: "bold" }}>&#42;</span>
                    </Form.Label>
                    <Form.Select
                      className={`modern-form-select ${fieldErrors.workExperience ? "error-field" : ""}`}
                      value={formData.workExperience}
                      onChange={(e) => handleFieldChange("workExperience", e.target.value)}
                    >
                      <option value='-1'>
                        <AutoTranslate targetLanguage={language.lang}>경력을 선택하세요.</AutoTranslate>
                      </option>
                      <option value='0'>
                        <AutoTranslate targetLanguage={language.lang}>경력 없음</AutoTranslate>
                      </option>
                      <option value='1'>
                        <AutoTranslate targetLanguage={language.lang}>1개월 미만</AutoTranslate>
                      </option>
                      <option value='3'>
                        <AutoTranslate targetLanguage={language.lang}>3개월 미만</AutoTranslate>
                      </option>
                      <option value='6'>
                        <AutoTranslate targetLanguage={language.lang}>6개월 미만</AutoTranslate>
                      </option>
                      <option value='12'>
                        <AutoTranslate targetLanguage={language.lang}>1년 미만</AutoTranslate>
                      </option>
                      <option value='36'>
                        <AutoTranslate targetLanguage={language.lang}>3년 미만</AutoTranslate>
                      </option>
                      <option value='60'>
                        <AutoTranslate targetLanguage={language.lang}>5년 미만</AutoTranslate>
                      </option>
                      <option value='61'>
                        <AutoTranslate targetLanguage={language.lang}>5년 이상</AutoTranslate>
                      </option>
                    </Form.Select>
                    <div className='error-message'>{fieldErrors.workExperience ? <AutoTranslate targetLanguage={language.lang}>경력을 선택해주세요.</AutoTranslate> : <span>&nbsp;</span>}</div>
                  </Form.Group>
                </div>
                <div className={`${Commons.IsMobile() ? "w-100" : "flex-between-center gap-3 w-100"} mb-4 px-2`}>
                  <div className={`${Commons.IsMobile() ? "w-100" : "w-50"}`}>
                    <RadioButtonGroup
                      label='흡연 여부'
                      name='smoking'
                      value={formData.smoking}
                      onChange={handleFieldChange}
                      error={fieldErrors.smoking ? "흡연 여부를 선택해주세요." : null}
                      options={[
                        { value: true, label: "흡연" },
                        { value: false, label: "비흡연" },
                      ]}
                      required={true}
                      targetLanguage={language.lang}
                    />
                  </div>
                  {!Commons.IsMobile() && (
                    <div className='w-50'>
                      <RadioButtonGroup
                        label='음주 여부'
                        name='drinking'
                        value={formData.drinking}
                        onChange={handleFieldChange}
                        error={fieldErrors.drinking ? "음주 여부를 선택해주세요." : null}
                        options={[
                          { value: true, label: "음주" },
                          { value: false, label: "비음주" },
                        ]}
                        required={true}
                        targetLanguage={language.lang}
                      />
                    </div>
                  )}
                </div>
                {Commons.IsMobile() && (
                  <div className='w-100 mb-4 px-2'>
                    <RadioButtonGroup
                      label='음주 여부'
                      name='drinking'
                      value={formData.drinking}
                      onChange={handleFieldChange}
                      error={fieldErrors.drinking ? "음주 여부를 선택해주세요." : null}
                      options={[
                        { value: true, label: "음주" },
                        { value: false, label: "비음주" },
                      ]}
                      required={true}
                      targetLanguage={language.lang}
                    />
                  </div>
                )}
              </Form>
            </div>
          )}
        </div>
      </Dialog>
      <KakaoAddress show={dialog1} onHide={() => setDialog1(false)} onReceivePost={HandleReceivePost} />
      <Dialog
        show={dialog2}
        onHide={() => {
          setDialog2(false);
          setSelectedFormData({
            jobDate: "",
            companyCode: "",
            companyName: "",
            siteId: "",
            siteName: "",
            date: "",
            eduStatus: "",
            location: "",
          });
        }}
        className='modern-dialog'
        title={
          <div className='flex-start-center gap-3'>
            <span>
              <AutoTranslate targetLanguage={language.lang}>{selectedFormData.siteName}</AutoTranslate>
              <AutoTranslate targetLanguage={language.lang}>신청 정보</AutoTranslate>
            </span>
            {selectedFormData.eduStatus === "W" && (
              <div className='modern-badge modern-badge-warning'>
                <AutoTranslate targetLanguage={language.lang}>대기 중</AutoTranslate>
              </div>
            )}
            {selectedFormData.eduStatus === "Y" && (
              <div className='modern-badge modern-badge-success'>
                <AutoTranslate targetLanguage={language.lang}>승인</AutoTranslate>
              </div>
            )}
            {selectedFormData.eduStatus === "N" && (
              <div className='modern-badge modern-badge-danger'>
                <AutoTranslate targetLanguage={language.lang}>반려</AutoTranslate>
              </div>
            )}
          </div>
        }
        footerChildren={
          <div>
            <Button
              className='modern-btn modern-btn-outline-primary'
              onClick={() => {
                setDialog2(false);
                navigate("/composed-education", {
                  state: {
                    company: { companyCode: selectedFormData.companyCode, companyName: selectedFormData.companyName },
                    site: { siteId: selectedFormData.siteId, siteName: selectedFormData.siteName },
                  },
                });
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>교육 현황 가기</AutoTranslate>
            </Button>
          </div>
        }
      >
        <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
          <Form.Group className='w-50 modern-form-group'>
            <Form.Label className='modern-form-label'>
              <AutoTranslate targetLanguage={language.lang}>사업장</AutoTranslate>
            </Form.Label>
            <Form.Control className='modern-form-control' type='text' value={selectedFormData.companyName ?? ""} disabled />
          </Form.Group>
          <Form.Group className='w-50 modern-form-group'>
            <Form.Label className='modern-form-label'>
              <AutoTranslate targetLanguage={language.lang}>현장</AutoTranslate>
            </Form.Label>
            <Form.Control className='modern-form-control' type='text' value={selectedFormData.siteName ?? ""} disabled />
          </Form.Group>
        </div>
        <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
          <Form.Group className='w-100 modern-form-group'>
            <Form.Label className='modern-form-label'>
              <AutoTranslate targetLanguage={language.lang}>위치</AutoTranslate>
            </Form.Label>
            <Form.Control className='modern-form-control' type='text' value={selectedFormData.location ?? ""} disabled />
          </Form.Group>
        </div>
        <div className='flex-between-center gap-3 w-100 mb-4 px-2'>
          <Form.Group className='w-50 modern-form-group'>
            <Form.Label className='modern-form-label'>
              <AutoTranslate targetLanguage={language.lang}>작업예정일</AutoTranslate>
            </Form.Label>
            <Form.Control className='modern-form-control' type='text' value={selectedFormData.jobDate ?? ""} disabled />
          </Form.Group>
          <Form.Group className='w-50 modern-form-group'>
            <Form.Label className='modern-form-label'>
              <AutoTranslate targetLanguage={language.lang}>등록일</AutoTranslate>
            </Form.Label>
            <Form.Control className='modern-form-control' type='text' value={selectedFormData.date ?? ""} disabled />
          </Form.Group>
        </div>
      </Dialog>
      <Dialog
        show={dialog3.show}
        onHide={() => setDialog3({ show: false, data: [] })}
        title={
          <div className='flex-start-center gap-2'>
            <span>📋</span>
            <span>더보기</span>
          </div>
        }
        className='modern-dialog'
        footer={false}
      >
        <div className='modern-event-list'>
          {dialog3.data.map((event, idx) => (
            <div
              key={idx}
              className={`modern-event-item ${event.eduStatus == "W" ? "modern-event-warning" : event.eduStatus == "Y" ? "modern-event-success" : "modern-event-danger"}`}
              title={event.site.sitename}
              onClick={(e) => {
                console.log("event: ", event);
                e.stopPropagation();
                setSelectedFormData({
                  jobDate: Commons.DateFormating(event.jobDate, 2),
                  companyCode: event.company.companyCode,
                  companyName: event.company.companyname,
                  siteId: event.site.siteId,
                  siteName: event.site.sitename,
                  date: Commons.DateFormating(event.date, 2),
                  eduStatus: event.eduStatus,
                  location: event.location,
                });
                setDialog2(true);
                setDialog3({ show: false, data: [] });
              }}
            >
              <div className='modern-event-content'>
                <span className='modern-event-name'>
                  <AutoTranslate targetLanguage={language.lang}>{event.site.sitename}</AutoTranslate>
                </span>
              </div>
            </div>
          ))}
        </div>
      </Dialog>
    </div>
  );
}

export default Calendars;
